var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedCryptoExperts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 114,
    height: 115,
    rx: 25,
    fill: "url(#paint0_linear_344_149)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 94,
    height: 95,
    rx: 20,
    fill: "url(#paint1_linear_344_149)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 63.0001C63.4434 63.0001 68.6667 57.7767 68.6667 51.3334C68.6667 44.8901 63.4434 39.6667 57 39.6667C50.5567 39.6667 45.3334 44.8901 45.3334 51.3334C45.3334 57.7767 50.5567 63.0001 57 63.0001Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6833 61.15L48.6666 76.3333L57 71.3333L65.3333 76.3333L63.3166 61.1333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_149",
    x1: 8.48936,
    y1: 5.44737,
    x2: 104.108,
    y2: 108.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_149",
    x1: 17,
    y1: 14.5,
    x2: 96,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(37 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCryptoExperts);
export default __webpack_public_path__ + "static/media/VerifiedCryptoExperts.c650f3ce82a00f4f9f83250fb83ca404.svg";
export { ForwardRef as ReactComponent };